// ============================================================================
// shared/hooks/useRefetchAlCerrarModal
// Con la navegación por modales, el listado queda MONTADO de fondo mientras el
// formulario (sub-ruta) se muestra en un modal. Al cerrar el modal (regresar a la
// ruta base del listado) el listado NO se re-monta, por lo que no vuelve a consultar
// solo. Este hook detecta ese regreso y ejecuta el refetch del listado para reflejar
// altas/ediciones hechas en el modal, conservando los filtros actuales (siguen en el
// estado del componente, que nunca se desmontó).
// ============================================================================
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useRefetchAlCerrarModal = (baseRuta: string, refetch: () => void) => {
  const { pathname } = useLocation();
  const rutaAnterior = useRef(pathname);
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  useEffect(() => {
    const anterior = rutaAnterior.current;
    rutaAnterior.current = pathname;

    // Solo al REGRESAR a la ruta base desde una sub-ruta (modal cerrado).
    if (
      pathname === baseRuta &&
      anterior !== baseRuta &&
      anterior.startsWith(`${baseRuta}/`)
    ) {
      refetchRef.current?.();
    }
    // Depende solo de pathname: refetch se lee siempre por ref (última versión).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};
